import React, { useState } from "react";
import { useContext } from "react";
import NoteContext from "../context/notes/noteContext";

export default function Textform(props) {
  const context = useContext(NoteContext);
  const { addNote } = context;

  const handleClick = (e) => {
    e.preventDefault();
    addNote(note.title, note.description, note.tag);
    setNote({title: "", description: "", tag: "Default"});
    props.showAlert("Note Added Successfully", "success");
  };

  const [note, setNote] = useState({ title: "", description: "", tag: "Default" });
  const clearOnClick = () => {
    setNote({ title: "", description: "", tag: "" });
  };
  const [history, setHistory] = useState([]);

  const saveToHistory = (newText) => {
    setHistory((prevHistory) => [...prevHistory, note]);
    setNote(newText);
  };

  const undoRecentOnClick = () => {
    if (history.length > 0) {
      const lastText = history[history.length - 1];
      setHistory(history.slice(0, -1));
      setNote(lastText);
    }
  };

  const uppercaseSelectedOnClick = () => {
    const textarea = document.getElementById("description");
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = note.description.substring(start, end);
    const newText =
      note.description.substring(0, start) +
      selectedText.toUpperCase() +
      note.description.substring(end);
    saveToHistory({ ...note, description: newText });
  };

  const lowercaseSelectedOnClick = () => {
    const textarea = document.getElementById("description");
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = note.description.substring(start, end);
    const newText =
      note.description.substring(0, start) +
      selectedText.toLowerCase() +
      note.description.substring(end);
    saveToHistory({ ...note, description: newText });
  };

  const capitalizeSelectedOnClick = () => {
    const textarea = document.getElementById("description");
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = note.description.substring(start, end);
    const newText =
      note.description.substring(0, start) +
      selectedText
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ") +
      note.description.substring(end);
    saveToHistory({ ...note, description: newText });
  };

  const undoOnClick = () => {
    undoRecentOnClick();
  };

  const handleonchange = (event) => {
    setNote({ ...note, [event.target.name]: event.target.value });
  };

  return (
    <>
      <div className="container">
        <div className="mb-3">
          <h1 id="header">{props.heading}</h1>
          <label htmlFor="title" className="form-label">
            Title
          </label>
          <input
            type="text"
            className="form-control"
            id="title"
            value={note.title}
            onChange={handleonchange}
            name="title"
            style={{
              backgroundColor: props.mode === "dark" ? "#3a4750" : "white",
              color: props.mode === "dark" ? "white" : "black",
            }}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="description" className="form-label">
            Description
          </label>
          <textarea
            name="description"
            id="description"
            type="text"
            className="form-control"
            value={note.description}
            rows={7}
            onChange={handleonchange}
            style={{
              backgroundColor: props.mode === "dark" ? "#3a4750" : "white",
              color: props.mode === "dark" ? "white" : "black",
              minHeight: "9em",
              maxHeight: "19em",
              overflowY: "auto",
            }}
            required
          ></textarea>
          <label htmlFor="tag" className="form-label">
            Tag
          </label>
          <select
            className="form-control"
            id="tag"
            value={note.tag}
            onChange={handleonchange}
            name="tag"
            style={{
              backgroundColor: props.mode === "dark" ? "#3a4750" : "white",
              color: props.mode === "dark" ? "white" : "black",
            }}
          >
            <option value="Default">Default</option>
            <option value="Personal">Personal</option>
            <option value="Important">Important</option>
            <option value="Fun">Fun</option>
            <option value="Official">Official</option>
          </select>
        </div>
        <button className="btn btn-dark mx-2" onClick={handleClick} disabled={note.description.length < 5}>
          Save
        </button>
        <button className="btn btn-dark mx-2" onClick={clearOnClick}>
          Clear
        </button>

        <div className="btn-group" style={{ float: "right", marginRight: "" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-skip-backward-circle-fill"
            viewBox="0 0 16 16"
            id="skip-backward"
            type="button"
            onClick={undoOnClick}
          >
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.79-2.907L8.5 7.028V5.5a.5.5 0 0 0-.79-.407L5 7.028V5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0V8.972l2.71 1.935a.5.5 0 0 0 .79-.407V8.972l2.71 1.935A.5.5 0 0 0 12 10.5v-5a.5.5 0 0 0-.79-.407" />
          </svg>
          <button
            type="button"
            className="btn btn-outline-success dropdown-toggle mx-3"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Edit-Text
          </button>
          <ul className="dropdown-menu">
            <li>
              <button className="dropdown-item" onClick={uppercaseSelectedOnClick}>
                Uppercase
              </button>
            </li>
            <li>
              <button className="dropdown-item" onClick={lowercaseSelectedOnClick}>
                Lowercase
              </button>
            </li>
            <li>
              <button className="dropdown-item" onClick={capitalizeSelectedOnClick}>
                Capitalize
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="container my-3" id="textstats">
        <h2>Text Properties</h2>
        <p>
          {note.description.split(/\s+/).filter((word) => word.length > 0).length} words and{" "}
          {note.description.replace(/\s/g, "").length} characters
        </p>
      </div>
    </>
  );
}
